// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JESA","comment":"styles_comment__EOlWr"};